/** Parse Content-Disposition and trigger a browser file download from a Response blob. */

export function parseContentDispositionFilename(cd: string | null, fallback: string): string {
  if (!cd) return fallback;
  const utfMatch = /filename\*=UTF-8''([^;\r\n]+)/i.exec(cd);
  if (utfMatch?.[1]) return decodeURIComponent(utfMatch[1].trim());
  const asciiMatch = /filename="([^"]+)"/i.exec(cd);
  if (asciiMatch?.[1]) return asciiMatch[1];
  return fallback;
}

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

/** Reads body as text and prefers JSON `{ message }` when present. */
export async function readFetchErrorMessage(response: Response, fallbackPrefix = 'Request failed'): Promise<string> {
  let msg = `${fallbackPrefix} (${response.status})`;
  try {
    const text = await response.text();
    if (!text) return msg;
    try {
      const json = JSON.parse(text) as { message?: string };
      return json.message?.trim() || (text.length > 280 ? `${text.slice(0, 280)}…` : text);
    } catch {
      return text.length > 280 ? `${text.slice(0, 280)}…` : text;
    }
  } catch {
    return msg;
  }
}

export async function downloadXlsxResponse(response: Response, fallbackFilename: string): Promise<void> {
  const blob = await response.blob();
  const filename = parseContentDispositionFilename(
    response.headers.get('Content-Disposition'),
    fallbackFilename
  );
  triggerBlobDownload(blob, filename);
}
